import { MView } from "@/styles/mobilePageStyles.tsx";
import { Text, View } from "@/styles/reactnative.tsx";
import { ThemeContext } from "@/theme/ThemeProvider.tsx";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FONTS, IMAGES } from "../../../constants";
import CImage from "../CImage";

const CNoDataFound = ({
  noDataTitle,
  noDataContent,
  noDataSize,
  noDataHeight,
  lottieSize,
}) => {
  const { theme, isDarkMode } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <View
      style={{
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "flex-start",
        width: "100%",
        position: "relative",
        minHeight: noDataHeight ? noDataHeight : "80%",
        backgroundColor: "transparent",
        borderRadius: 10,
        padding: "40px 20px",
      }}
    >
      <MView style={{ marginBottom: 8 }}>
        <CImage
          src={IMAGES.nodata}
          style={{
            width: "auto",
            height: 32,
            opacity: 0.5,
          }}
          alt={""}
        />
      </MView>
      {noDataTitle ? (
        <MView
          style={{
            paddingTop: 8,
            paddingBottom: 8,
            paddingInline: 10,
          }}
        >
          <Text style={{
            fontSize: 13,
            fontWeight: 500,
            color: theme.COLORS.textsilver,
            textAlign: "center",
          }}>
            {t(noDataTitle)}
          </Text>
        </MView>
      ) : null}
      {noDataContent ? (
        <MView style={{ paddingTop: 12, paddingBottom: 12 }}>
          <Text
            style={{
              fontSize: 12,
              color: theme.COLORS.textsilver,
              letterSpacing: 0,
              textAlign: "center",
              opacity: 0.7,
            }}
          >
            {t(noDataContent)}
          </Text>
        </MView>
      ) : null}
    </View>
  );
};
export default React.memo(CNoDataFound);
